<template>
    <!-- 页面头部 组件-->
    <div class="header_wrap">
        <div class="control-btn flex" @click="extend" :title="isCollapse ? '展开菜单' : '收起菜单'">
            <i class="icon iconfont" :class="[isCollapse ? 'icon-right-extend' : 'icon-extend_open']"></i>
        </div>
        <breadcrumb></breadcrumb>
        <div class="menu">
            <div class="version-history" title="更新日志" @click="go2VersionHistory()">
                <i class="el-icon-bell"></i>
            </div>
            <div class="question" title="问题反馈">
                <i class="el-icon-headset"></i>
            </div>
            <screenfull/>
            <img class="avatar" :src="userInfo.thumb_avatar" alt="" />
            <el-dropdown class="username" @command="handleCommand">
                <!-- 用户名下拉菜单 -->
                <span class="el-dropdown-link">
                    {{ userInfo.name }}

                    <i class="iconfont icon-a-Basic_frontpage"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="loginout"><i class="el-icon-switch-button"></i> 退出登录</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>
<script>
    import avatarIcon from '../assets/images/avatar.png'
    import { EventBus } from '@/assets/js/event-bus'
    import { getAccountInfo, outLogin } from '@r/api'
    import breadcrumb from '@c/breadcrumb.vue'
    import screenfull from '@c/screenfull.vue'

    export default {
        components: { breadcrumb, screenfull },
        name: 'headerPage',
        props: {
            tip: '',
            tipsSecond: '',
            tipsThree: '',
            path: ''
        },
        data() {
            return {
                userInfo: {
                    username: 'admin',
                    avatar: avatarIcon
                },
                isCollapse: false
            }
        },
        mounted() {
            let userInfo = this.$cookies.get('user_info') || {}
            userInfo = { ...this.userInfo, ...userInfo }
            this.userInfo = userInfo
            EventBus.$on('updateUserInfo', val => {
                this.userInfo = val
            })
            EventBus.$on('isCollapse', val => {
                this.isCollapse = val
            })
        },
        methods: {
            // 用户名下拉菜单选择事件
            handleCommand(command) {
                if (command == 'loginout') {
                    outLogin().then(
                        data => {
                            this.$store.commit('menuIndex', 'reportList')
                            this.$router.push({ name: 'login' })
                            sessionStorage.setItem('index', 'reportList')
                        },
                        err => {
                            this.$message.error('系统错误')
                            sessionStorage.setItem('index', 'reportList')
                        }
                    )
                }
                if (command == 'goPwd') {
                    this.$router.push({ name: 'passwordChange' })
                }
            },
            go2VersionHistory() {
                window.open("https://doc.weixin.qq.com/doc/w3_ACkAqAYZAB41UaS1HTET8i2OyIrWV?scode=ALMA3QcaABAxf2nWnf")
            },
            extend() {
                this.isCollapse = !this.isCollapse
                EventBus.$emit('changeMenuExtend')
            }
        }
    }
</script>
<style>
    .header_wrap {
        box-sizing: border-box;
        height: 50px;
        background: #fff;
        line-height: 50px;
        margin-bottom: 1px;
        padding: 0 15px 0 0;
        box-shadow: 0 4px 11px 0 #e8e8e8;
    }
    .header_wrap .control-btn {
        margin-right: 8px;
        float: left;
        padding: 0 15px;
        height: 100%;
        cursor: pointer;
        transition: background 0.3s;
    }
    .header_wrap .control-btn:hover {
        background: rgba(0, 0, 0, 0.025);
    }
    .header_wrap .control-btn .iconfont {
        color: #5a5e66 !important;
    }
    .header_wrap p {
        font-weight: 800;
        font-size: 16px;
        float: left;
    }
    .header_wrap .menu {
        float: right;
        display: flex;
        align-items: center;
    }
    .header_wrap .menu .avatar {
        width: 24px;
        height: 24px;
        margin-right: 5px;
        margin-top: -2px;
    }
    .header_wrap .menu .username {
        font-size: 14px;
        color: #606266;
        cursor: pointer;
    }
    .header_wrap .menu .version-history,
    .header_wrap .menu .question {
        height: 50px;
        padding: 0 15px;
        font-size: 16px;
        cursor: pointer;
        transition: all 0.3s;
        display: inline-flex;
        align-items: center;
    }
    .header_wrap .menu .version-history:hover,
    .header_wrap .menu .question:hover {
        background: rgba(0, 0, 0, 0.025);
    }
    .header_wrap .menu .question:hover::after {
        content: "";
        width: 120px;
        height: 120px;
        background: url("https://spotlight.istarshine.com/upload/qrcode_liyancai.png");
        background-size: contain;
        border-radius: 6px;
        position: absolute;
        top: 60px; right: 120px;
        z-index: 10000;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5)
    }
</style>



// WEBPACK FOOTER //
// src/components/header_page.vue